import { createVegaChart, renderCustomBarChart } from "./vega_chart_helpers";

export function initializeChart(container_id, grid_item, chart_configuration = {}){
  console.log("initializeChart", container_id, grid_item, chart_configuration)

  if(grid_item.find(".custom-bar-chart").length > 0){
    // Render simple bar chart from aggregated labels data
    const chart_container = $(container_id);
    const ajaxResponseData = eval(chart_container.data("graphService")); // array of {label_id, label_name, value}
    const labelkey = chart_container.data("labelKey") || 'post_count';

    const axisTitleMap = {
      mentions: 'Post Count',
      post_count: 'Post Count',
      likes_count: 'Like Count',
      views_count: 'View Count',
      comments_count: 'Comment Count',
      shares_count: 'Share Count',
      engagement: 'Engagement',
      avg_likes_count: 'Average Like Count',
      avg_views_count: 'Average View Count',
      avg_comments_count: 'Average Comment Count',
      avg_shares_count: 'Average Share Count',
      avg_engagement: 'Average Engagement'
    };
    const yAxisTitle = axisTitleMap[String(labelkey)] || 'Value';

    if (!ajaxResponseData || ajaxResponseData.length === 0) { return; }

    let dimensions = {}

    dimensions = adjustGraphDimensions(grid_item.width(), grid_item.height())
    if(grid_item.parent().find("article header p").text().length > 0) dimensions.height = dimensions.height - 40

    renderCustomBarChart(container_id, ajaxResponseData, dimensions, {y: yAxisTitle})

  } else {
    var chart_container = $(container_id)
    var breakdownAttribute = chart_container.data("breakdownAttribute")
    var ajaxResponseData = eval(chart_container.data("graphService"));
    var labelkey = chart_container.data("labelKey");
    var legendTitle = chart_container.data("legendTitle");

    var chartLayout = chart_configuration.chartLayout;
    var chartScale = chart_configuration.chartScale;
    var hidePoint = chart_configuration.hidePoint;

    if (ajaxResponseData) {
      let graph_settings_enabled = grid_item.find(".graph-settings").length > 0

      let dimensions = {}
      if(chart_configuration.dimensions){
        dimensions = chart_configuration.dimensions
      } else {
        dimensions = adjustGraphDimensions(grid_item.width(), grid_item.height())
      }

      if(graph_settings_enabled) dimensions.height = dimensions.height - 40
      if(grid_item.parent().find("article header p").text().length > 0) dimensions.height = dimensions.height - 40

      createVegaChart(container_id, labelkey, ajaxResponseData, breakdownAttribute, chartLayout, hidePoint, chartScale, dimensions.width, dimensions.height, false, legendTitle)
    }
  }
}

export function adjustGraphDimensions(container_width, container_height){
  return { width: container_width - 80, height: container_height - 40 }
}